export default __webpack_public_path__ + "media/zurb/img/lab/playground/foundation-icon-fonts-3/svgs/fi-trash-d68ed617bf6e66e61328a49981b3136b.svg";